import { render } from "./CustomizerView.vue?vue&type=template&id=10f716a9"
import script from "./CustomizerView.vue?vue&type=script&lang=js"
export * from "./CustomizerView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__